//list of paths to all promo versions of pages
export const promoLinks = [
  `radio/promo`,
  `tv/promo`,
  `app/promo`,
  `apple-tv/promo`,
  `alexa-skill/promo`,
  `radio-promotion/promo`,
  "join",
]